import { SimpleField } from './SimpleField';

export default SimpleField;
